<template>
    <div v-if="$route.name === 'profile' || +$route.params.id === user.id" class="pt-4 profile-menu">
        <v-layout :class="{'column': $vuetify.breakpoint.smAndDown}" wrap>
            <v-layout wrap xs10 md9
                      align-center
            >
                <v-flex mb-2>
                    <linkSpriteIcon icon="edit" class="mr-4"
                                    @click.native="OPEN_MODAL('user_info')"
                    >{{ $t('Редактировать профиль') }}
                    </linkSpriteIcon>
                </v-flex>
                <v-flex mb-2>
                    <linkSpriteIcon icon="password" class="mr-4"
                                    @click.native="OPEN_MODAL('change_password')"
                    >{{ $t('Изменить пароль') }}
                    </linkSpriteIcon>
                </v-flex>
                <v-flex v-if="user.available_certificates && user.available_certificates.length > 0" class="course-certificates" mb-2>
                    <v-select
                        solo
                        :items="user.available_certificates"
                        item-value="course_passing_id"
                        item-text="name"
                        append-icon=""
                        class="download_certificate"
                        :value="false"
                        :single-line="true"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @input="download_course_certificate($event)"
                    >
                        <template #append>
                          <v-icon aria-hidden="true" translate="no">
                            expand_more
                          </v-icon>
                        </template>
                        <template slot="label">
                            <linkIcon icon="" class="">{{ $t('Сертификаты о прохождении курсов') }}</linkIcon>
                            <v-icon color="#E2173D" size="20" class="" aria-hidden="true" translate="no">mdi-seal</v-icon>
                        </template>
                        <template slot-scope="props" slot="selection">
                            <linkIcon icon="" class="">{{ $t('Сертификаты о прохождении курсов') }}</linkIcon>
                            <v-icon color="#E2173D" size="20" class="">mdi-seal</v-icon>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex v-if="available_annual_certificates && available_annual_certificates.length > 0" class="user-annual-certificates" mb-2>
                    <v-select
                        solo
                        attach
                        :items="available_annual_certificates"
                        item-value="id"
                        item-text="name"
                        append-icon=""
                        class="download_certificate"
                        :value="false"
                        :single-line="true"
                        :menu-props="{ bottom: true, offsetY: true }"
                        @input="download_annual_certificate($event)"
                    >
                        <template #append>
                          <v-icon aria-hidden="true" translate="no">
                            expand_more
                          </v-icon>
                        </template>
                        <template slot="label">
                            <link-sprite-icon size="40px" :icon="'cert'" class="text-lg-center">
                                {{ $t('Сертификат о достижении уровня «Эксперт»') }}
                            </link-sprite-icon>
                        </template>
                        <template slot-scope="props" slot="selection">
                            <link-sprite-icon size="40px" :icon="'cert'" class="text-lg-center">
                                {{ $t('Сертификат о достижении уровня «Эксперт»') }}
                            </link-sprite-icon>
                        </template>
                    </v-select>
                </v-flex>
            </v-layout>
            <v-layout v-if="full" xs2 md3
                      mb-2
                      row
                      align-center
                      justify-end
            >
                <v-flex md9 class="mr-3 text-xs-right">{{ $t('Заполнение профиля') }}</v-flex>
                <v-flex md3 mr-2>
                    <v-progress-circular
                        :rotate="-90"
                        :size="64"
                        :width="6"
                        :value="full"
                        class="green-text"
                    >
                        {{ full }}%
                    </v-progress-circular>
                </v-flex>
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
import linkSpriteIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import linkIcon from '@/components/ui/links/with_icon/link_icon';
import modalEditInfo from './user_modals/user_info_edit';
import modalPasswordChange from './user_modals/user_change_password';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import api from '@/api/index';

export default {
  components: {
    linkSpriteIcon,
    linkIcon,
    modalEditInfo,
    modalPasswordChange,
  },
  props: {
    full: {
      type: Number,
    },
    user: {
      type   : Object,
      default: () => Object.create(null),
    },
  },
  computed: {
    ...mapGetters('profile/menu', [
      'profile_menu',
    ]),
    ...mapGetters('profile/user', [
      'user',
      'available_annual_certificates',
    ]),
    ...mapGetters('profile/modals', [
      'user_info',
      'change_password',
    ]),
    ...mapGetters('course', ['certificate_url']),
  },
  methods: {
    ...mapMutations('profile/modals', [
      'OPEN_MODAL',
    ]),
    ...mapActions('course', ['get_certificate']),
    async download_course_certificate(course_passing_id) {
      await this.get_certificate(course_passing_id);
      let win = window.open(this.certificate_url.url, '_blank');
      win.focus();
    },
    async download_annual_certificate(id) {
      let win = window.open(`/api/certificate/annual/user/${id}`, '_blank');
      win.focus();
    },
  },
};
</script>

